module.exports = __webpack_public_path__ + "static/media/scanned.34aa505a.mp3";